// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Permission Elevation API
 * API for engineers to elevate and de-elevate their permissions within Aura.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import type {
  MainUserAccessResponse,
  RequestElevatePermissionsRequest,
  ResponseElevationResponse,
} from '../models/index';
import {
  MainUserAccessResponseFromJSON,
  MainUserAccessResponseToJSON,
  RequestElevatePermissionsRequestFromJSON,
  RequestElevatePermissionsRequestToJSON,
  ResponseElevationResponseFromJSON,
  ResponseElevationResponseToJSON,
} from '../models/index';

export interface V1ElevationsAccessTypeDeleteRequest {
  accessType: V1ElevationsAccessTypeDeleteAccessTypeEnum;
}

export interface V1ElevationsPostRequest {
  elevation: RequestElevatePermissionsRequest;
}

/**
 *
 */
export class ElevationApi extends runtime.BaseAPI {
  /**
   * Remove the calling engineer\'s elevated access of the given type.
   * De-elevate permissions
   */
  async v1ElevationsAccessTypeDeleteRaw(
    requestParameters: V1ElevationsAccessTypeDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ResponseElevationResponse>> {
    if (requestParameters['accessType'] == null) {
      throw new runtime.RequiredError(
        'accessType',
        'Required parameter "accessType" was null or undefined when calling v1ElevationsAccessTypeDelete().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Omni-Authorization'] =
        await this.configuration.apiKey('X-Omni-Authorization'); // OmniAuthorization authentication
    }

    let urlPath = `/v1/elevations/{accessType}`;
    urlPath = urlPath.replace(
      `{${'accessType'}}`,
      encodeURIComponent(String(requestParameters['accessType'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'DELETE',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      ResponseElevationResponseFromJSON(jsonValue),
    );
  }

  /**
   * Remove the calling engineer\'s elevated access of the given type.
   * De-elevate permissions
   */
  async v1ElevationsAccessTypeDelete(
    requestParameters: V1ElevationsAccessTypeDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ResponseElevationResponse> {
    const response = await this.v1ElevationsAccessTypeDeleteRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Request elevated access of the given type for the calling engineer. A justification is required, and is used for review. The team is optional metadata recorded for the audit trail, never an authorisation input.
   * Elevate permissions
   */
  async v1ElevationsPostRaw(
    requestParameters: V1ElevationsPostRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ResponseElevationResponse>> {
    if (requestParameters['elevation'] == null) {
      throw new runtime.RequiredError(
        'elevation',
        'Required parameter "elevation" was null or undefined when calling v1ElevationsPost().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Omni-Authorization'] =
        await this.configuration.apiKey('X-Omni-Authorization'); // OmniAuthorization authentication
    }

    let urlPath = `/v1/elevations`;

    const response = await this.request(
      {
        path: urlPath,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: RequestElevatePermissionsRequestToJSON(
          requestParameters['elevation'],
        ),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      ResponseElevationResponseFromJSON(jsonValue),
    );
  }

  /**
   * Request elevated access of the given type for the calling engineer. A justification is required, and is used for review. The team is optional metadata recorded for the audit trail, never an authorisation input.
   * Elevate permissions
   */
  async v1ElevationsPost(
    requestParameters: V1ElevationsPostRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ResponseElevationResponse> {
    const response = await this.v1ElevationsPostRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Returns the authenticated caller\'s email and subject, including allowed elevation levels.
   * Get user access
   */
  async v1UserAccessGetRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<MainUserAccessResponse>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Omni-Authorization'] =
        await this.configuration.apiKey('X-Omni-Authorization'); // OmniAuthorization authentication
    }

    let urlPath = `/v1/user-access`;

    const response = await this.request(
      {
        path: urlPath,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      MainUserAccessResponseFromJSON(jsonValue),
    );
  }

  /**
   * Returns the authenticated caller\'s email and subject, including allowed elevation levels.
   * Get user access
   */
  async v1UserAccessGet(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<MainUserAccessResponse> {
    const response = await this.v1UserAccessGetRaw(initOverrides);
    return await response.value();
  }
}

/**
 * @export
 */
export const V1ElevationsAccessTypeDeleteAccessTypeEnum = {
  Production: 'production',
  Admin: 'admin',
  PlatformAdmin: 'platformAdmin',
} as const;
export type V1ElevationsAccessTypeDeleteAccessTypeEnum =
  (typeof V1ElevationsAccessTypeDeleteAccessTypeEnum)[keyof typeof V1ElevationsAccessTypeDeleteAccessTypeEnum];
